module.exports = __webpack_public_path__ + "img/item5.1230390d.png";